import { Box, Grid, Typography } from "@mui/material";
import AudioCompare from "../../Utilities/AudioCompare";

import bassSimOn from "../../../static/audio/distant_bass_suite/bass-sim-on.mp3";
import bassSimOff from "../../../static/audio/distant_bass_suite/bass-sim-off.mp3";
import { BASS_SIM_OFF_WAVEFORM, BASS_SIM_ON_WAVEFORM } from "./audioWaveforms";

const BASS_SIM_AUDIO = {
  audios: [
    { src: bassSimOn, label: "Bass Sim", waveform: BASS_SIM_ON_WAVEFORM },
    { src: bassSimOff, label: "Original guitar", waveform: BASS_SIM_OFF_WAVEFORM },
  ],
};

const BassSim = () => {
  return (
    <Box
      sx={{
        px: { xs: 3, md: 5 },
        py: { xs: 6, md: 8 },
        color: "#111",
        background: "radial-gradient(circle, #F9F5EE 0%, #B8B2AA 100%)",
      }}
    >
      <Grid container justifyContent="center">
        <Grid item xs={12} md={8} lg={6}>
          <Typography variant="h3" sx={{ textAlign: "center", mb: 3 }}>
            Built-in Bass Sim
          </Typography>
          <Typography variant="h6" sx={{ textAlign: "center" }}>
            No bass guitar? No problem. Feed BassSuite - Distant a clean electric guitar DI, and the built-in Bass Sim transforms the signal into a convincing bass foundation, ready for the pedals, amplifiers, and cabinet chain.
          </Typography>

          <Box
            sx={{
              mt: 4,
              p: { xs: 2, md: 2.5 },
              color: "#F9F5EE",
              background: "radial-gradient(circle at top, #3a3a3a 0%, #1a1a1a 72%)",
              border: "1px solid rgba(249, 245, 238, 0.16)",
              borderRadius: 2,
              boxShadow: "0 14px 32px rgba(0, 0, 0, 0.3)",
            }}
          >
            <Typography variant="overline" sx={{ color: "#F9F5EE", fontWeight: 800, letterSpacing: "0.16em" }}>
              Source comparison
            </Typography>
            <Typography variant="h6" sx={{ mt: -0.25, fontWeight: 700 }}>
              Hear the Bass Sim transformation
            </Typography>
            <AudioCompare section={BASS_SIM_AUDIO} dense crossfadeMs={650} appearance="showcase" />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default BassSim;
